const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKollektivtrafikBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "kollektivtrafik",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 327.9 99.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "e98822bb-0e10-4161-9e46-dd207facd9db",
    "data-name": "border",
    d: "M4.05.25h93s1.78,7,1.58,8.88,36,.31,36.75,1.36a15.79,15.79,0,0,1,1.53,3.06H240.26s1.47-3,4.31-3.06,25.15-1.05,25.7,0A40.17,40.17,0,0,0,273,14.26s50.31-1.64,51.45-.12.31,28.88,1.14,31a38.2,38.2,0,0,1,1.93,14.54c-.56,5.78-.56,19.67-1.38,22s-34.84,8-38.21,8.87-29.65-1.23-31.51-.74-4.89,8.67-15.72,8.67-15-9-16.56-9.54-98.45.87-98.45.87-5.1,9.85-16.4,9.3-15.74-9.19-15.77-9.55S46.7,89.23,45.6,87.14s-2-8.38-2-8.38a15,15,0,0,1-9.41,3.59c-6,.23-17.46.53-17.92-2.79s.47-14.32-4.13-14.6a79.06,79.06,0,0,1-8.14-.91L2.3,12.73s-2-.51-2-3.6S-.88,1.9,4.05.25Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKollektivtrafikBorder);
export default __webpack_public_path__ + "static/media/kollektivtrafik-border.f36358c6bb9a6839d546dc38fc298e2e.svg";
export { ForwardRef as ReactComponent };